import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IToast, LayoutService, ToastService } from 'codex-lib';
import { Envelope } from '../model/envelope';
import { TranslateService } from '@ngx-translate/core';
import { EnvelopeService } from '../services/envelope.service';
@Component({
  selector: 'app-envelope-details-delete',
  templateUrl: './envelope-details-delete.component.html',
  styleUrls: ['./envelope-details-delete.component.scss']
})
export class EnvelopeDetailsDeleteComponent implements OnInit {

  @Input() elementSelected: Envelope;
  @Output() modalCloseEmmiter = new EventEmitter();
  @Output() deleteEnvelope = new EventEmitter();

  envelopeForm: FormGroup;
  envelopeDetail: Envelope;

  envelope = { id: 0, reasonDelete: '' };

  constructor(
    private modalService: NgbModal,
    private translateService: TranslateService,
    private envelopeService: EnvelopeService,
    private layoutService: LayoutService,
    private toastService: ToastService
  ) { }

  get id() {
    return this.envelopeForm.get('id');
  }
  get reasonDelete() {
    return this.envelopeForm.get('reasonDelete');
  }

  ngOnInit() {
    this.envelope.id = this.elementSelected.id;

    this.envelopeForm = new FormGroup({
      id: new FormControl(this.envelope.id, Validators.required),
      reasonDelete: new FormControl(this.envelope.reasonDelete, Validators.required)
    });
  }

  onDeleteEnvelope() {

    this.layoutService.toggleLoading(true);

    if (this.envelopeForm.valid) {
      this.envelopeService
        .delete(this.id.value, this.reasonDelete.value)
        .subscribe(
          response => {
            this.layoutService.toggleLoading(false);
            const toast: IToast = {
              text: this.translateService.instant('envelope.delete-modal.toast.deleteSucess'),
              autoHide: true,
              type: 'success'
            };
            this.toastService.createNewToast(toast);
            this.deleteEnvelope.emit();
            this.modalService.dismissAll();
          },
          error => this.layoutService.toggleLoading(false)
        );
    }
  }

  modalClose() {
    this.modalCloseEmmiter.emit(true);
    this.modalService.dismissAll();
  }
}
